import React from 'react';
import { Link } from 'react-router-dom';

import Uvp from '../../../components/Uvp';
import SignInButton from '../../../components/buttons/SignInButton';
import CWIcon from '../../../components/icons/CWIcon';
import useSupportedCurrencies from '../../../hooks/useSupportedCurrencies';

function HeroCurrenciesLink() {
  const supportedCurrencies = useSupportedCurrencies();
  const count = supportedCurrencies.count || '...';
  const scrollToPricePairs = () => {
    const section = document.getElementById('price-pairs');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', '#price-pairs');
    }
  };

  return <div className="landing-hero-currencies">
    <span className="landing-hero-currencies-tooltip-wrap">
      <button className="landing-hero-currencies-link" type="button" onClick={scrollToPricePairs}>Show All {count} Currencies →</button>
      <span className="landing-hero-currencies-tooltip" role="tooltip">{supportedCurrencies.flaggedList || 'Loading...'}</span>
    </span>
    <div className="landing-hero-docs-link"><Link className="landing-hero-currencies-link" to="/api-documentation">See API Docs →</Link></div>
    <div className="landing-hero-docs-link"><Link className="landing-hero-currencies-link" to="/blog">See Integration Guides →</Link></div>
    <div className="landing-hero-docs-link"><Link className="landing-hero-currencies-link" to="/mcp">Connect GoldAPI.io to ChatGPT, Claude →</Link></div>
  </div>;
}

function HomeHero() {
  return <section className="landing-hero">
    <div className="landing-hero-shell">
      <div className="row align-items-center">
        <div className="col-lg-5"><div className="landing-hero-copy">
          <div className="landing-greeting lead text-muted">
            <span>Hi, नमस्ते,<span className="hide-small"> 你好,</span> مرحبا </span>&nbsp;&nbsp;
            <CWIcon theme="dark" size={34}/>&nbsp;&nbsp;<span>Gold</span>API.io is Minimalistic
          </div>
          <h1 className="display-4 my-3"><span className="hl-gold">Gold</span> &amp; <span className="hl-silver">Silver</span> Prices JSON API</h1>
          <h2 className="subtitle lead text-muted my-3">100% Real-Time & Historical Gold, Silver, Platinum & Palladium Prices, LBMA Benchmarks & FX Rates — Powered by REST API, WebSockets & MCP Server for Businesses, Developers and AI Agents</h2>
          <div className="landing-hero-cta"><SignInButton align="left" /></div>
          <HeroCurrenciesLink />
        </div></div>
        <div className="col-lg-7"><div className="landing-hero-visual"><Uvp /></div></div>
      </div>
    </div>
  </section>;
}

export default HomeHero;
